// MUI Imports
import { useTheme } from '@mui/material/styles';

// Type Imports
import type { VerticalMenuContextProps } from '../../../@menu/components/vertical-menu/Menu';

// Component Imports
import HorizontalNav, { Menu, MenuItem } from '../../../@menu/horizontal-menu';

import { useSettings } from '../../../@core/hooks/useSettings';
// Hook Imports
import useVerticalNav from '../../../@menu/hooks/useVerticalNav';

// Styled Component Imports
import StyledHorizontalNavExpandIcon from '../../../@menu/styles/horizontal/StyledHorizontalNavExpandIcon';
import StyledVerticalNavExpandIcon from '../../../@menu/styles/vertical/StyledVerticalNavExpandIcon';

import { DsIcon } from '../../../../components/icons/DsIcon';
import menuItemStyles from '../../../@core/styles/horizontal/menuItemStyles';
// Style Imports
import menuRootStyles from '../../../@core/styles/horizontal/menuRootStyles';
import verticalMenuItemStyles from '../../../@core/styles/vertical/menuItemStyles';
import verticalMenuSectionStyles from '../../../@core/styles/vertical/menuSectionStyles';
import verticalNavigationCustomStyles from '../../../@core/styles/vertical/navigationCustomStyles';
import { VerticalNavContent } from './VerticalNavContent';

type RenderExpandIconProps = {
  level?: number;
};

type RenderVerticalExpandIconProps = {
  open?: boolean;
  transitionDuration?: VerticalMenuContextProps['transitionDuration'];
};

const RenderExpandIcon = ({ level }: RenderExpandIconProps) => (
  <StyledHorizontalNavExpandIcon level={level}>
    <DsIcon icon="CHEVRON_RIGHT" />
  </StyledHorizontalNavExpandIcon>
);

const RenderVerticalExpandIcon = ({ open, transitionDuration }: RenderVerticalExpandIconProps) => (
  <StyledVerticalNavExpandIcon open={open} transitionDuration={transitionDuration}>
    <DsIcon icon="CHEVRON_RIGHT" />
  </StyledVerticalNavExpandIcon>
);

export const HorizontalMenu = () => {
  // Hooks
  const verticalNavOptions = useVerticalNav();
  const theme = useTheme();
  const { settings } = useSettings();

  // Vars
  const { skin } = settings;
  const { transitionDuration } = verticalNavOptions;

  return (
    <HorizontalNav
      switchToVertical
      verticalNavContent={VerticalNavContent}
      verticalNavProps={{
        customStyles: verticalNavigationCustomStyles(verticalNavOptions, theme),
        backgroundColor:
          skin === 'bordered' ? 'var(--mui-palette-background-paper)' : 'var(--mui-palette-background-default)',
      }}
    >
      <Menu
        rootStyles={menuRootStyles(theme)}
        renderExpandIcon={({ level }) => <RenderExpandIcon level={level} />}
        // renderExpandedMenuItemIcon={{ icon: <DsIcon customIcon={<LuPlusCircle />} /> }}
        menuItemStyles={menuItemStyles(theme, 'ri-circle-line')}
        popoutMenuOffset={{
          mainAxis: ({ level }) => (level && level > 0 ? 4 : 16),
          alignmentAxis: 0,
        }}
        verticalMenuProps={{
          menuItemStyles: verticalMenuItemStyles(verticalNavOptions, theme),
          renderExpandIcon: ({ open }) => (
            <RenderVerticalExpandIcon open={open} transitionDuration={transitionDuration} />
          ),
          renderExpandedMenuItemIcon: {
            icon: <DsIcon icon="PLUS_CIRCLE_FILL" />,
          },
          menuSectionStyles: verticalMenuSectionStyles(verticalNavOptions, theme),
        }}
      >
        <MenuItem href="/" icon={<DsIcon icon="HOME" />}>
          Home
        </MenuItem>
        <MenuItem href="/about" icon={<DsIcon icon="INFO_CIRCLE" />}>
          About
        </MenuItem>
      </Menu>

      {/* <Menu
        rootStyles={menuRootStyles(theme)}
        renderExpandIcon={({ level }) => <RenderExpandIcon level={level} />}
        renderExpandedMenuItemIcon={{ icon: <DsIcon customIcon={<LuPlusCircle /> }}
        menuItemStyles={menuItemStyles(theme, 'ri-circle-line')}
        popoutMenuOffset={{
          mainAxis: ({ level }) => (level && level > 0 ? 4 : 16),
          alignmentAxis: 0
        }}
        verticalMenuProps={{
          menuItemStyles: verticalMenuItemStyles(verticalNavOptions, theme),
          renderExpandIcon: ({ open }) => (
            <RenderVerticalExpandIcon open={open} transitionDuration={transitionDuration} />
          ),
          renderExpandedMenuItemIcon: { icon: <DsIcon customIcon={<LuPlusCircle /> },
          menuSectionStyles: verticalMenuSectionStyles(verticalNavOptions, theme)
        }}
      >
        <GenerateHorizontalMenu menuData={menuData(dictionary)} />
      </Menu> */}
    </HorizontalNav>
  );
};
